var scope_0 = require('/home/runner/work/spm-ui-addon-devenv/spm-ui-addon-devenv/cookbook/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a22bd93ad71746daa5364b507166ab7d.js').default;
var scope_1 = require('/home/runner/work/spm-ui-addon-devenv/spm-ui-addon-devenv/cookbook/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    